<template>
    <div class="relative " :class="signing?'overflow-hidden':''">
        <div class="p-6">
        <h1 class="text-2xl font-medium mb-2">Entente prêt de terminal moneris</h1>
        
        <p class="border-b border-gray-700 pb-2 mb-2">Remplir et signez.</p>
        
            
        <p class="text-xs text-gray-800 pb-2">Livro.ca Inc. remet un terminal de paiement Moneris à {{ name }} pour une période de temps indéterminée afin de limiter les interactions aux bureaux de Livro en temps de pandémie.</p>

        <p class="text-xs text-gray-800 pb-2">Si tu effectues plus de 30 livraisons par semaine avec le terminal, celui-ci vous sera prêté sans frais. Advenant que vous fassiez moins de 30 livraisons par semaine, un frais de $8 vous sera facturé (et déduit) à tous les semaines.</p>

        <p class="text-xs text-gray-800 pb-2">Tous bris majeur, ou perte du terminal occasionnera un frais unique de $350 pour le remplacement du terminal.</p>

        <p class="text-xs text-gray-800 pb-2">En complétant le formulaire ci-bas, vous êtes d'accord avec les termes de cette entente.</p>
        
        <p class="text-xs text-gray-800 pb-2">Pour toutes questions:</p>
        
        <p class="text-xs text-gray-800 pb-2" >Contactez le bureau au 
            <a href="tel:4508581310" class="text-indigo-600">(450) 858-1310</a></p>
         
        <div class="border-b border-gray-700 pb-2 mb-2"></div>
        

        <TextField label="Votre nom complèt" v-model="name" :disabled="true" class="mb-2" />
        <TextField label="Votre numéro de téléphone" v-model="phone" :disabled="true" class="mb-2" />
        
        <div>SIGNÉ EN DATE DU {{ date }}</div>

        <button class="bg-indigo-600 w-full rounded-lg px-6 py-4 uppercase font-medium text-white text-center mt-8" type="button" @click="start_signing">Signer</button>
        
        <div v-if="signing" class="fixed text-white inset-0 bg-indigo-700">
            <div class="text-2xl font-medium p-4 text-center">Signer</div>
            <canvas width="100%" ref="canvas" height="200" v-touch:start="touchDown" v-touch:end="touchUp" v-touch:moving="touchMove"></canvas>
            
            <div class="flex items-center p-4 justify-between">
                
                <div @click="clear" class="bg-white text-indigo-600 rounded-lg px-6 py-4 uppercase font-medium text-center mt-8">Effacer</div>
                <div v-if="moves>25" @click="save" class="bg-white text-indigo-600 rounded-lg px-6 py-4 uppercase font-medium text-center mt-8">Soumettre</div>
            </div>
            
        </div>
        </div>
    </div>
</template>

<script>

import moment from "moment";
import TextField from "../../Shared/TextField";
export default {
    name: "Moneris",
    props: ['driver'],
    components: {TextField},
    data() {
        return {
            signing: false,
            name: this.driver.name,
            phone: this.driver.phone,
            date: moment().format("Y-M-D"),
            lastX: 0,
            lastY: 0,
            lineWidth: 0,
            context: null,
            moves: 0,
        }
    },
    

    methods: {

        start_signing() {
            this.signing = true;
            this.$nextTick(() => {
                this.clear();
            })
            
            
        },
        
        clear() {
            let canvas = this.$refs.canvas;
            let context = canvas.getContext("2d");
            // let parent = canvas.parentNode;
            //
            canvas.width  = window.innerWidth;
            canvas.height = 200;

            this.lineWidth = Math.round(Math.min(canvas.width, canvas.height) * 0.01);
            context.strokeStyle = "#000000";
            context.lineCap = "round";
            context.lineJoin = "round";
            context.lineWidth = this.lineWidth;
            context.fillStyle = "#FFFFFF";
            context.fillRect(0, 0, canvas.width, canvas.height);
            this.moves = 0;
        },
        
        touchDown(ev) {
            let canvas = this.$refs.canvas;
            let context = canvas.getContext("2d");
            let canvasRect = this.$refs.canvas.getBoundingClientRect();
            this.lastX = ev.touches[0].clientX - canvasRect.left;
            this.lastY = ev.touches[0].clientY - canvasRect.top;
            context.beginPath();
            context.arc(this.lastX, this.lastY, Math.round(this.lineWidth / 2), 0, 2 * Math.PI, false);
            context.fillStyle = "#000000";
            context.fill();
        },

        touchUp() {

        },

        touchMove(ev) {

            let canvas = this.$refs.canvas;
            let context = canvas.getContext("2d");
            let canvasRect = this.$refs.canvas.getBoundingClientRect();
            let x = ev.touches[0].clientX - canvasRect.left, y = ev.touches[0].clientY - canvasRect.top;
            context.beginPath();
            context.moveTo(this.lastX, this.lastY);
            context.lineTo(x, y);
            context.stroke();
            this.lastX = x;
            this.lastY = y;
            this.moves++;
        },
        
        save() {

            const image = this.$refs.canvas.toDataURL();
            window.axios.post('/moneris-agreement/' + this.driver.id, {
                image: image
            }).then(response => {
                window.location.reload();
            });
            
        }
    }

}
</script>

<style scoped>

</style>
